export type BrowserPlatform =
  | 'macos'
  | 'windows'
  | 'ios'
  | 'android'
  | 'linux'
  | 'other';

/** The operating system the page runs on, read from the user agent */
export function browserPlatform(): BrowserPlatform {
  const userAgent = navigator.userAgent;
  if (/Android/i.test(userAgent)) return 'android';
  if (/iPhone|iPad|iPod/i.test(userAgent)) return 'ios';
  // iPadOS Safari reports a Mac user agent; only the touch screen tells it apart
  if (/Macintosh|Mac OS X/i.test(userAgent)) {
    return navigator.maxTouchPoints > 1 ? 'ios' : 'macos';
  }
  if (/Windows/i.test(userAgent)) return 'windows';
  if (/Linux|CrOS|X11/i.test(userAgent)) return 'linux';
  return 'other';
}

/** The desktop app ships for macOS and Windows only */
export const canOpenDesktopApp = (platform: BrowserPlatform): boolean =>
  platform === 'macos' || platform === 'windows';
